import React from "react";
import { Grid, Popup } from "semantic-ui-react";
import "./PropertyGrid.scss";

export function PropertyGrid({ children, error = false }: React.PropsWithChildren<{ error?: boolean }>) {
  return (
    <Grid columns='equal' className={"property-grid" + (error ? " error" : "")}>
      {children}
    </Grid>
  );
}

PropertyGrid.Row = ({
  children,
  label,
  valueString,
}: React.PropsWithChildren<{ label: string; valueString: string }>) => {
  return (
    <Grid.Row>
      <Grid.Column>{label}</Grid.Column>
      <Popup
        inverted
        content={valueString}
        trigger={<Grid.Column className='ellipsis whitespace-pre-line'>{children}</Grid.Column>}
      />
    </Grid.Row>
  );
};
